import { render, staticRenderFns } from "./TaskDeleteModal.vue?vue&type=template&id=2cd9f2d4&"
import script from "./TaskDeleteModal.vue?vue&type=script&lang=js&"
export * from "./TaskDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports